export function formatFieldValue(value) {
  if (value === null || value === undefined || value === '') return '-/-';
  return value;
}
